import { render } from "./FormularioDatosGenerales.vue?vue&type=template&id=eb8661dc&scoped=true&ts=true"
import script from "./FormularioDatosGenerales.vue?vue&type=script&lang=ts"
export * from "./FormularioDatosGenerales.vue?vue&type=script&lang=ts"

import "./FormularioDatosGenerales.vue?vue&type=style&index=0&id=eb8661dc&scoped=true&lang=scss"

import exportComponent from "C:\\AgentesAzure\\SVRAPQAHIR01\\vsts-agent-win-x64-4.261.0\\_work\\4\\s\\hircasa-srp-webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb8661dc"]])

export default __exports__